import { register } from '../../../JavaScript/Utils';

declare global {
  interface Window {
    Splide?: Splide
  }
}

// Temporary solution since the type 'Splide' from Carousel.types does not seem constructable
type Splide = any

export const BikeSlider = (el: HTMLElement) => {
  const init = () => {
    const Splide = window.Splide
    const sliderContainer = el.querySelector('.splide-wrapper')
    const ariaLabelPrev: string = el.querySelector('.splide__arrow--prev')?.getAttribute('data-aria-label-prev') || '';
    const ariaLabelNext: string = el.querySelector('.splide__arrow--next')?.getAttribute('data-aria-label-next') || '';
    const ariaLabelLast: string = el.querySelector('.splide__arrow--prev')?.getAttribute('data-aria-label-last') || '';
    const ariaLabelFirst: string = el.querySelector('.splide__arrow--next')?.getAttribute('data-aria-label-first') || '';

    const BikeSlider = new Splide(sliderContainer, {
      type: "fade",
      rewind: true,
      arrows: true,
      perPage: 1,
      perMove: 1,
      pagination: false,
      i18n: {
        prev: ariaLabelPrev,
        next: ariaLabelNext,
        last: ariaLabelLast,
        first: ariaLabelFirst,
      }
    })
    BikeSlider.mount( )
  }
  init()
}

register('BikeSlider', BikeSlider)
